import { TRACKING_URL_PARAMS } from '../url-keys'
import { FILTER_KEY_CALENDARS, FILTER_KEY_LOCATION, FILTER_KEY_PARTNERSHIP } from '../filter-keys'
import { urlParamsWithNamespace } from '@/helpers/url-params'

export default {
  // Q: Can we use a Map instead, so the keys can be objects instead of this stringification stuff?
  // A: No, because Vue reactivity does not work for Maps
  detailsForIds: (state) => (points) => {
    if (state.locationDetailsLookup[JSON.stringify(points)]) {
      return state.locationDetailsLookup[JSON.stringify(points)]
    }
  },

  newEventPath: (state, getters) => {
    if (getters.calendarSlug) {
      if (state.searchedLocation) {
        const {latitude, longitude} = state.searchedLocation
        const queryParams = urlParamsWithNamespace({latitude, longitude}, 'searched_location')
        const queryString = new URLSearchParams(queryParams).toString()
        return `/calendars/${getters.calendarSlug}/events/start?${queryString}`
      } else {
        return `/calendars/${getters.calendarSlug}/events/start`
      }
    } else if (getters.partnershipSlug) {
      return `/partnerships/${getters.partnershipSlug}/events/new`
    } else {
      return '/events/new'
    }
  },

  newGroupPath: (state, getters) => {
    if (state.searchedLocation) {
      const {latitude, longitude} = state.searchedLocation
      const query = getters.searchedLocationQuery
      const queryParams = urlParamsWithNamespace({latitude, longitude, query}, 'location')
      queryParams.user_country = window.Agra.Configuration.locationSearchBias.country
      const queryString = new URLSearchParams(queryParams).toString()
      return `/groups/new?${queryString}`
    } else {
      return '/groups/new'
    }
  },

  calendarSlug: (state) => {
    const calendarFilter = state.filters.filter(f => FILTER_KEY_CALENDARS === f.type)
    // if there is one calendar being filtered by, we know the calendar slug.
    return calendarFilter.length === 1 ? calendarFilter[0].value[0] : null
  },

  geoJsonPoints: (state) => {
    return {
      type: 'FeatureCollection',
      features: state.points.map(p => ({
        type: 'Feature',
        properties: {
          id: p.id,
          type: p.type,
          key: p.key,
          icon: 'circle'
        },
        geometry: {
          type: 'Point',
          coordinates: [p.lon, p.lat]
        }
      }))
    }
  },

  otherSearchParams(_state, getters) {
    const searchParams = new URLSearchParams(window.location.search)
    const otherSearchParams = {}
    getters.urlKeysIncludedInItemPageUrls.forEach(k => {
      if (searchParams.get(k)) {
        otherSearchParams[k] = searchParams.get(k)
      }
    })
    return otherSearchParams
  },

  // Filters for the URL of the page.
  // Don't include filters that are not explicitly configured to be included in the URL.
  pageUrlFilterOptions(state, getters) {
    return {
      filters: state.filters.filter(f => state.urlFilterKeys.includes(f.type)),
      otherSearchParams: getters.otherSearchParams,
      pagination: {currentPage: state.pagination.page}
    }
  },

  partnershipSlug: (state) => {
    const partnershipFilter = state.filters.filter(f => FILTER_KEY_PARTNERSHIP === f.type)
    // if there is a partnership being filtered by, return its slug
    return partnershipFilter.length === 1 ? partnershipFilter[0].value : null
  },

  searchedLocationQuery: (state) => {
    const locationFilter = state.filters.filter(f => FILTER_KEY_LOCATION === f.type)
    return locationFilter.length === 1 ? locationFilter[0].value : null
  },

  showNewEventButton: (state) => {
    if (state.forceCreateEventButtonHidden) {
      return false
    }

    if (!state.eventCreationAllowed) {
      return false
    } else {
      if (state.eventCreationRequiresSearchedLocation) {
        return !!state.searchedLocation
      } else {
        return true
      }
    }
  },

  urlKeysIncludedInItemPageUrls: (state) => {
    return [ ...TRACKING_URL_PARAMS, ...state.additionalUrlKeysIncludedInItemPageUrls]
  }
}
